import { Component, type ErrorInfo, type ReactNode } from "react";

import { trackTelemetryError } from "./telemetry";
import { translate as t } from "./locale";

export class TelemetryErrorBoundary extends Component<
    {
        children: ReactNode;
        reportError?: typeof trackTelemetryError;
    },
    { failed: boolean }
> {
    public state = { failed: false };

    public static getDerivedStateFromError(): { failed: boolean } {
        return { failed: true };
    }

    public componentDidCatch(error: Error, info: ErrorInfo): void {
        const withComponentStack = new Error(error.message);
        withComponentStack.name = error.name;
        withComponentStack.stack = `${error.stack ?? ""}\n${info.componentStack ?? ""}`;
        (this.props.reportError ?? trackTelemetryError)(withComponentStack, "react_boundary");
    }

    public render(): ReactNode {
        if (this.state.failed)
            return <main className="startup-error"><p className="form-error">{t("Nie udało się uruchomić aplikacji")}</p></main>;
        return this.props.children;
    }
}
